import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoService } from '../../../shared/services/crypto.service';
import { API_ENDPOINTS } from '../../../shared/utils/const';
import { ApiService } from '../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-sso-landing',
  templateUrl: './sso-landing.component.html',
  styleUrl: './sso-landing.component.css'
})
export class SsoLandingComponent {

  public loginObj: any = {
    username: '',
    password: '',
    userType: ''
  }

  public userData = {
    msMeUserId: '',
    msMeUserName: '',
    name: '',
    ownersMobileNumber: '',
    message: '',
    loginStatus: '',
    token: '',
    isActive: false,
    userId: '',
    email: ''
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cryptoService: CryptoService,
    private apiService: ApiService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      // Invalid SSO attempt
      this.router.navigate(['/login']);
      return;
    }
    sessionStorage.setItem('authToken', token);
    this.MSMElogin(token);

  }


  MSMElogin(token:any) {

    let isMSMELoginSuccessful = false; // Flag to track success or failure

    this.apiService.getRequest(API_ENDPOINTS.LOGIN.MSMESSO).subscribe(
      (res: any) => {
        console.log("Response Received:", res);
        if (res.status) {
          // Login successful
          isMSMELoginSuccessful = true;

          this.toastr.success(res.message);

          sessionStorage.setItem('authToken', token);
          sessionStorage.setItem('singInAs', 'MsMeUser');
          sessionStorage.setItem('isUserLoggedIn', 'true');
          sessionStorage.setItem('UserType', 'MSME');
          sessionStorage.setItem('isApproved', res.isApproved);
          sessionStorage.setItem('isProfileCompleted', res.isProfileCompleted);
          sessionStorage.setItem('Gender', res.gender);
          sessionStorage.setItem('SocialCategory', res.socialCategory);
          sessionStorage.setItem('msMeUserName', res.udyamRegistrationNumber);
          sessionStorage.setItem('ownersMobileNumber', res.ownersMobileNumber);



          this.userData = {
            msMeUserId: res.MsMeUserId,
            msMeUserName: res.MsMeUserName,
            name: res.Name,
            ownersMobileNumber: res.OwnersMobileNumber,
            message: res.message,
            loginStatus: res.status,
            token: res.token,
            isActive: res.IsActive,
            userId: res.MsMeId,
            email: res.Email,
          };



          //Object.keys(this.userData).forEach((key) => {
          //  const value = this.userData[key as keyof typeof this.userData];
          //  sessionStorage.setItem(key, String(value));
          //});

          this.router.navigate(['/msmeuserprofile']);
        } else {
          // Login failed
          isMSMELoginSuccessful = false;
          this.toastr.error(res.message);
          this.router.navigate(['/login']);
        }
      },
      //error: (err) => {
      //  isMSMELoginSuccessful = false;
      //  this.toastr.error('SSO login failed');
      //  this.router.navigate(['/login']);
      //}
    );
  }
}




